function initFixedHeader(){
    var headerHeight = parseInt($('header .main-header').innerHeight());
    $('#page-header').css('padding-top',headerHeight);
    $('header .main-header').addClass('fixed');

    $(document).on('scrollUp', function () { //define a custom event listener
        if (window.matchMedia("(max-width: 1400px)").matches) {
            if ($(window).scrollTop() <= 350) {
                $('header .main-header').removeClass('scrolldown');
                $('header .main-header .wrap').show(200);
            }
        }
    });

    $(document).on('scrollDown', function () { //define a custom event listener
        if (window.matchMedia("(max-width: 1400px)").matches && $(window).scrollTop() > 200)  {
            $('header .main-header').addClass('scrolldown');
            $('header .main-header .wrap').hide(200);
        }
    });
}